<template>
  <el-table :data="rows" size="mini" border v-loading="loading" :empty-text="text.historyEmpty" :max-height="maxHeight">
    <el-table-column :label="text.historyAtColumn" width="170" prop="at"></el-table-column>
    <el-table-column v-if="showTarget" :label="text.historyTargetColumn" width="130">
      <template slot-scope="scope">{{ scope.row.targetText }}</template>
    </el-table-column>
    <el-table-column :label="text.historyActionColumn" width="90">
      <template slot-scope="scope">{{ scope.row.actionText }}</template>
    </el-table-column>
    <el-table-column :label="text.historyDetailColumn" min-width="320">
      <template slot-scope="scope">{{ scope.row.detailText || '-' }}</template>
    </el-table-column>
    <el-table-column :label="text.historyActorColumn" width="140" prop="actor"></el-table-column>
  </el-table>
</template>

<script>
import { historyActionText, historyDetailSummary, historyTargetLabel } from '@/utils/callpopOrg'
import { CALLPOP_TEXT } from '@/utils/callpopText'

/**
 * 조직 변경 이력 표 — 화면 #4 와 매장 행의 「이력」 다이얼로그가 **같은 것**을 쓴다.
 *
 * `detail_json` 을 한글 한 줄로 바꾸는 일은 순수 함수([historyDetailSummary]) 한 곳이다. 두 자리가 각자
 * 적으면 같은 이력 행이 화면마다 다른 말을 한다.
 *
 * **PK 를 이름으로 푸는 것은 서버가 준 사전이다**([refs], §3-5). 화면이 마스터를 다시 읽지 않고, 사전에
 * 없는 PK(지워진 대상)는 코드를 그대로 보인다 — 이름을 지어내지 않는다.
 */
export default {
  name: 'OrgHistoryTable',

  props: {
    /** `GET /callpop/history` 또는 `GET /callpop/stores/{cd}/mapping/history` 의 항목 */
    items: { type: Array, default: () => [] },
    /** 같은 응답 최상위의 `refs`(`utils/callpopOrg.refsOf` 로 정규화한 것) */
    refs: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    /** 매장 한 곳의 이력에는 대상 열이 필요 없다(전부 그 매장의 매핑이다) */
    showTarget: { type: Boolean, default: true },
    maxHeight: { type: [Number, String], default: null },
  },

  data() {
    return { text: CALLPOP_TEXT }
  },

  computed: {
    rows() {
      return (Array.isArray(this.items) ? this.items : []).map((row) => ({
        id: row.id,
        at: row.at,
        actor: row.actor || '-',
        targetText: historyTargetLabel(row, this.refs),
        actionText: historyActionText(row.action),
        detailText: historyDetailSummary(row, this.refs),
      }))
    },
  },
}
</script>
